import {generalSplitTest} from '../../utils/constants/signalmanConstants';

class GeneralSplitTest {
  constructor() {
    this.flag = generalSplitTest;
    this.dataLayerPush();
  }

  dataLayerPush() {
    return window.dataLayer.push({
      event: 'ab_test_group',
      ab_test_name: '2024 10 02 aa in catalog',
      ab_test_location: 'plp catalog',
      ab_test_group: this.flag
    });
  }
}

ProductCatalog.GeneralSplitTest = new GeneralSplitTest();
